<template>
  <div class="clearfix">
    <a-upload
      accept="image/*"
      action="/api/file/upload/picture"
      listType="picture-card"
      :fileList="fileList"
      :withCredentials="true"
      @preview="handlePreview"
      :showUploadList="{showPreviewIcon: true,showRemoveIcon:false}"
    ></a-upload>

    <a-modal width="1000px" :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="图片" style="width: 100%" :src="previewImage">
    </a-modal>
  </div>
</template>

<script>
import eBase from "@/base/eBase.js";
import _ from "underscore";

export default {
  props: {
    value: { required: true }
  },

  data() {
    return {
      previewVisible: false,
      previewImage: "",
      fileList: []
    };
  },

  created() {
    eBase.debug("[DynamicImage.vue][created][enter]");
  },

  mounted() {
    eBase.debug("[DynamicImage.vue][mounted][enter]");
    this.fileList = this.transforToList(this.value);
  },

  watch: {
    value: {
      handler(newValue, oldValue) {
        this.fileList = this.transforToList(newValue);
      },
      immediated: true
    }
  },

  computed: {},

  methods: {
    handleCancel() {
      this.previewVisible = false;
    },

    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },

    transforToList(arr) {
      const result = [];

      if (!_.isArray(arr)) {
        return [];
      }
      _.each(arr, (one, index) => {
        let oneFile = {
          url: one,
          status: "done",
          uid: index,
          name: one
        };
        result.push(oneFile);
      });

      return result;
    }
  } // EOF methods
};
</script>



// WEBPACK FOOTER //
// src/components/select/DynamicImage.vue